import { FOCUSABLE_ELM_QUERY } from '../directives/trapFocus';

export default {
  methods: {
    _af_autoFocus: function() {
      if (typeof window === 'undefined') {
        return;
      }
      if (this.$refs.focus) {
        console.log('_af_ref_focus');
        this.$refs.focus.focus();
      } else if (this.$refs.focus_container) {
        console.log('_af_ref_focus_container');
        this.$refs.focus_container.querySelector(FOCUSABLE_ELM_QUERY).focus();
      } else if (this.$el) {
        const el = this.$el.querySelector(FOCUSABLE_ELM_QUERY);
        el && el.focus();
        console.log('_af_ref_el', el);
      }

      this.$el.querySelector(FOCUSABLE_ELM_QUERY).focus();
      console.log('_af_', document.activeElement);
    },
  },
}